import { Box } from "@mui/material";
import { TextField } from "../../../../v2/MUI_custom_component";
import { useState } from "react";
import {
  validateName,
  nameInputValidation,
} from "../../../Common/Validation/nameValidation";
import {
  validateMobile,
  mobileInputValidation,
} from "../../../Common/Validation/mobileValidation";
import { encryptPassword } from "../../../../v2/Utils/Encryption/NodeForgeEncryption";
import { handleResendOTP } from "../API/Utils";
import { OTP_PURPOSE_ENUM } from "../../../Auth/Enum";
import { OTPValidation } from "./OTPValidation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

export const AddAdminStaffForm = ({
  selectedRole,
  firmId,
  onClose,
  fetchEmployeeDetails,
  setShowStaffPermissionModal,
  onStaffOtpVerified,
}) => {
  const [formData, setFormData] = useState({
    full_name: "",
    phone_number: "",
  });
  const [error, setError] = useState({ full_name: "", phone_number: "" });
  const [isLoading, setIsLoading] = useState(false);
  const userId = useSelector((state) => state.loginReducer.loginUser?.user_id);
  const encryptedUserId = encryptPassword(String(userId));
  const [showOTPComponent, setShowOTPComponent] = useState(false);
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setError((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSendOTP = async () => {
    const nameValidation = validateName(formData.full_name);
    setError((prev) => ({
      ...prev,
      full_name: nameValidation.valid ? "" : nameValidation.message,
    }));
    const mobileValidation = validateMobile(formData.phone_number);
    setError((prev) => ({
      ...prev,
      phone_number: mobileValidation.valid ? "" : mobileValidation.message,
    }));
    if (!mobileValidation.valid || !nameValidation.valid) return;

    if (nameValidation.valid && mobileValidation.valid) {
      setIsLoading(true);
      const payload = {
        mobile_number: encryptPassword(formData.phone_number),
        purpose: OTP_PURPOSE_ENUM.EMPLOYEE,
        user_id: encryptedUserId,
      };
      const response = await handleResendOTP(payload);
      setIsLoading(false);
      return response;
    }
  };

  const handleVerifySuccess = () => {
    try {
      // Reset form
      setFormData({ full_name: "", phone_number: "" });
      onClose();
    } catch (error) {
      console.error("Error refreshing employee data:", error);
      toast.error("Failed to refresh data. Please try again.");
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <TextField
        label={`${selectedRole.label} Name*`}
        placeholder={`Enter ${selectedRole.label.toLowerCase()} full name`}
        value={formData.full_name}
        onChange={(e) => {
          const val = nameInputValidation(e.target.value);
          handleInputChange("full_name", val);
        }}
        fullWidth
        error={!!error.full_name}
        helperText={error.full_name}
      />
      <TextField
        label={`Mobile Number*`}
        value={formData.phone_number}
        onChange={(e) => {
          const val = mobileInputValidation(e.target.value);
          handleInputChange("phone_number", val);
        }}
        placeholder="Enter Mobile number"
        error={!!error.phone_number}
        helperText={error.phone_number}
        disabled={showOTPComponent}
      />
      <OTPValidation
        mobileNumber={formData.phone_number}
        handleSendOTP={handleSendOTP}
        isLoading={isLoading}
        error={error}
        formData={formData}
        onCloseModal={onClose}
        onVerifySuccess={handleVerifySuccess}
        firmId={firmId}
        role={selectedRole}
        permissions={null}
        setShowStaffPermissionModal={setShowStaffPermissionModal}
        onStaffOtpVerified={onStaffOtpVerified}
        refreshFunction={fetchEmployeeDetails}
        setShowOTPComponent={setShowOTPComponent}
        showOTPComponent={showOTPComponent}
      />
    </Box>
  );
};
